import * as $ from "jquery";
import { Grid } from 'ag-grid-community';
import { param } from "jquery";

export default class ReceiptComponent {
    constructor() {
        this.componentSelector = "#order-receipt";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('#js-search-receipt').off().on('click', function () {
            instance.searchReceipt(instance);
        });
    }

    searchReceipt(instance) {
        let receiptNumber = $('#receiptnumber').val();

        if (receiptNumber == "") {
            bootbox.alert("Du måste ange ett ordernummer.");
            return;
        }

        axios({
            method: 'post',
            url: "/orderapi/getreceiptbyreceiptnumber",
            data: { receiptNumber: receiptNumber }
        }).then(function (response) {
            instance.render(instance, JSON.parse(response.data));
        }).catch(function (response) {
            bootbox.alert("Inget kvitto matchade sökningen.");
        });
    }

    download(instance, data) {
        var receiptNumber = data.Description != '' ? data.Description : data.Identifier
        var uri = "/orderapi/recreatereceiptpdf";
        var fileName = receiptNumber + ".pdf";

        var x = new XMLHttpRequest();
        x.open("POST", uri, true);
        x.responseType = "blob";
        x.onload = function (e) { download(e.target.response, fileName, "application/pdf"); };

        var formsData = new FormData();
        formsData.append('base64', data.Base64FileData);
        formsData.append('orderNumber', receiptNumber);
        x.send(formsData);

        if (typeof (callback) === 'function')
            callback();
    }

    buttonRenderer(params) {
        var button = document.createElement('button');
        button.innerHTML = 'Ladda ner';
        button.addEventListener('click', function () {
            params.context.download(params.context, params.data)
        });
        return button;
    }

    render(instance, data) {
        if (instance.grid == null) {
            instance.grid = {
                context: instance,
                columnDefs: [
                    { headerName: 'Kvittonummer', field: 'Identifier' },
                    
                    { headerName: 'Ordernummer', field: 'Description' },
                    { headerName: 'Kundnummer', field: 'ExtendedInfo' },
                    {
                        headerName: "",
                        field: 'Identifier',
                        cellRenderer: instance.buttonRenderer,
                        width: 160,
                    }
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight'
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }
    }
}